import React from "react";
import { faGithub, faGitlab } from "@fortawesome/free-brands-svg-icons";

import { ScmType } from "@protos/common/v1/common";
import { useBasePath } from "@shared/hooks";

import {
  SetupProjectChooseType,
  SMSProjectTypeOption,
} from "./SetupProjectChooseType";

const OPTIONS: SMSProjectTypeOption[] = [
  {
    scmType: ScmType.GITHUB,
    title: "GitHub",
    faIcon: faGithub,
  },
  {
    scmType: ScmType.GITLAB,
    title: "GitLab",
    faIcon: faGitlab,
  },
];

export function SetupProjectChooseSMSType() {
  const basePath = useBasePath();

  const getNextLink = (option: SMSProjectTypeOption) => {
    if (
      option.scmType === ScmType.GITHUB // both GitHub and GitHub Enterprise
    ) {
      return `${basePath}/setup/managed`;
    } else {
      return `${basePath}/settings/source-code`;
    }
  };

  return (
    <SetupProjectChooseType
      title="Scan new project with Semgrep Managed Scans"
      options={OPTIONS}
      getNextLink={getNextLink}
    />
  );
}
